import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {Modal} from "antd";
import {
    ARRAY_COLORS,
    ARRAY_COLORS_1,
    ARRAY_COLORS_DRAW,
    ARRAY_COLORS_MAIN, ARRAY_DEFAULT_COLORS,
    DEFAULT_CANVAS_BACKGROUND
} from "../../Const";
import {generateUUID2, imgPathPerfix} from "../../utils";
import {Alpha, hexToHsva, hexToRgba, hsvaToHexa, validHex} from "@uiw/react-color";
import {HsvaColor} from "@uiw/color-convert/src/index";
import {useTranslation} from "react-i18next";
import {IconClose} from "../../Icon";
import {UIAppStateContext} from "../../../@excalidraw/packages/excalidraw/context/ui-appState";
import {t} from "i18next";

let mState;
let mType:any;
const DialogColorChoose = forwardRef((props:{onCanvasBackgroundEvent:any,appState:any},ref)=>{
    const {t} = useTranslation();
    const [canvasBackgroundColor,setCanvasBackgroundColor]=useState(DEFAULT_CANVAS_BACKGROUND);
    const [canvasTempBackgroundColor,setCanvasTempBackgroundColor]=useState(DEFAULT_CANVAS_BACKGROUND);
    const [isDialogVisible,setIsDialogVisible]=useState(false);
    const [isEyeDropVisible, setIsEyeDropVisible] = useState(false);
    const [isAllPage,setIsAllPage] = useState(false);

    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
        onCloseDialog:onCloseDialog
    }));

    const onShowDialog = (szCanvasBackground,state,isAllPage=true,type:string)=>{
        setCanvasBackgroundColor(szCanvasBackground);
        setIsDialogVisible(true)
        mState = state;
        mType = type;
        setIsAllPage(isAllPage);
    }

    const onCloseDialog = ()=>{
        setIsDialogVisible(false);
    }

    useEffect(()=>{
        setCanvasTempBackgroundColor(canvasBackgroundColor)
    },[canvasBackgroundColor])

    /**
     * 最近颜色
     */
    const getLastestColors = ()=>{
        let arrayColors = [];
        const colors = localStorage.getItem("lastestCanvasColor");
        if (colors != null && colors !== ''){
            arrayColors = JSON.parse(colors);
        }
        return arrayColors;
    }
    //保存最近的颜色
    const setLastestColors = (szNewHexColor:string)=>{
        let arrayColors = getLastestColors();
        //remove 重复的...
        for (let i=arrayColors.length-1;i>=0;i--){
            if (arrayColors[i].toLowerCase() === szNewHexColor.toLowerCase()){
                arrayColors.splice(i,1);
            }
        }
        let maxCount = arrayColors.length;
        if (maxCount > 17){
            maxCount = 17;
        }
        let arrayNewColors = [szNewHexColor];
        for (let i=0;i<maxCount;i++){
            arrayNewColors.push(arrayColors[i]);
        }
        localStorage.setItem("lastestCanvasColor",JSON.stringify(arrayNewColors));
    }

    return(
        <UIAppStateContext.Provider value={props.appState}>
            <Modal visible={isDialogVisible} width='248px' closable={false} closeIcon={<IconClose/>} onCancel={()=>setIsDialogVisible(false)} footer={''} centered={true}>
                <div className='font-size-12'
                     style={{margin: '-24px -24px -32px -24px', padding: '18px 15px', backgroundColor: 'transparent'}}>
                    <span>{t("Default colors")}</span>
                    <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '2px'}}>
                        {
                            ARRAY_DEFAULT_COLORS.map(item => <div className={'cursor-pointer'} key={generateUUID2()}
                                                                  data-color={item} style={{
                                width: '20px',
                                height: '20px',
                                margin: '3px 2px',
                                backgroundColor: item,
                                borderRadius: '10px',
                                border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
                            }} onClick={(e) => {
                                let szHexColor = e.currentTarget.dataset.color;
                                setCanvasBackgroundColor(szHexColor as string);
                                props.onCanvasBackgroundEvent(szHexColor as string, false, isAllPage, mType);

                                setLastestColors(szHexColor as string);
                            }}>

                            </div>)
                        }
                    </div>
                    <div className={'line'} style={{margin: '10px 0'}}></div>

                    <span>{t("palette")}</span>
                    <div style={{display: 'flex', flexWrap: 'wrap'}}>
                        {
                            ARRAY_COLORS.map(item => <div key={generateUUID2()} data-color={item} style={{
                                width: '20px',
                                height: '20px',
                                margin: '3px 2px',
                                cursor: 'pointer',
                                backgroundColor: item,
                                borderRadius: '2px',
                                border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
                            }} onClick={(e) => {
                                let szHex = e.currentTarget.dataset.color;
                                setCanvasBackgroundColor(szHex as string);
                                props.onCanvasBackgroundEvent(szHex as string, false, isAllPage, mType);
                                setLastestColors(szHex as string);
                            }}></div>)
                        }
                    </div>
                    {/*{ h: 0, s: 0, v: 0, a: 1 }*/}
                    <div style={{height: '12px'}}></div>
                    <div className='flex-row-vertical-center' style={{width: '100%'}}>
                        {/*<div className='flex-center' style={{width:'18px',height:'18px',backgroundColor:isEyeDropVisible?'#efefef':'transparent'}}>*/}
                        {/*{*/}
                        {/*    isEyeDropVisible &&*/}
                        {/*    <EyeDropper onCancel={()=>{*/}
                        {/*    }}*/}
                        {/*                onSelect={(color, event) =>{*/}
                        {/*                    setCanvasBackgroundColor(color);*/}
                        {/*                    props.onCanvasBackgroundEvent(color);*/}
                        {/*                }} onChange={()=>{*/}

                        {/*    }} colorPickerType={"elementStroke"}>*/}

                        {/*    </EyeDropper>*/}
                        {/*}*/}
                        {/*<img className='img-mini-small-12 hovered' src={imgPathPerfix()+"pick_color.png"} onClick={()=>{*/}
                        {/*    setIsEyeDropVisible(true);*/}
                        {/*}*/}
                        {/*}/>*/}
                        {/*</div>*/}
                        <Alpha
                            style={{flexGrow: '1', marginLeft: '0px'}}
                            hsva={
                                hexToHsva(canvasBackgroundColor || DEFAULT_CANVAS_BACKGROUND)
                            }
                            onChange={(newShade) => {
                                let szHexColor = hsvaToHexa(newShade as HsvaColor);
                                setCanvasBackgroundColor(szHexColor);
                                props.onCanvasBackgroundEvent(szHexColor, false, isAllPage, mType);
                                console.log(Math.round(hexToRgba(szHexColor || DEFAULT_CANVAS_BACKGROUND).a * 100) + '%')
                            }}
                        />
                    </div>

                    <div style={{marginTop: '12px', width: '100%'}}>
                        <span>HEX</span>
                        <input readOnly={false} className={'input-border'} style={{
                            flexGrow: '1',
                            borderRadius: '4px',
                            outline: 'none',
                            margin: '0 16px',
                            height: '24px',
                            textAlign: 'center',
                            width: '130px'
                        }} onFocus={(e)=>{
                            e.currentTarget.select();
                        }} onDoubleClick={(e)=>{
                            e.currentTarget.select();
                        }}
                               value={
                                   canvasTempBackgroundColor
                               }

                               onChange={(e) => {
                                   const szHexColor = e.currentTarget.value;

                                   if (validHex(szHexColor)) {
                                       setCanvasBackgroundColor(szHexColor);
                                       props.onCanvasBackgroundEvent(szHexColor, false, isAllPage, mType);
                                   } else {
                                       let szOriHex = 'TRANSPARENT';

                                   }
                                   setCanvasTempBackgroundColor(szHexColor);
                               }}
                        />
                        <span>{
                            // console.log(Math.ceil(hexToRgba(excalidrawRef?.getAppState()?.viewBackgroundColor || DEFAULT_CANVAS_BACKGROUND).a*100) +'%')
                            Math.round(hexToRgba(canvasBackgroundColor || DEFAULT_CANVAS_BACKGROUND).a * 100) + '%'
                        }</span>
                    </div>
                    <div className='line' style={{margin: '12px 0'}}></div>

                    <span className='text-color-a'>{t("lastestUse")}</span>
                    <div style={{display: 'flex', flexWrap: 'wrap'}}>
                        {
                            getLastestColors().map(item => <div key={generateUUID2()} data-color={item} style={{
                                width: '20px',
                                height: '20px',
                                margin: '3px 2px',
                                cursor: 'pointer',
                                backgroundColor: item,
                                borderRadius: '2px',
                                border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
                            }} onClick={(e) => {
                                let szHexColor = e.currentTarget.dataset.color;
                                setCanvasBackgroundColor(szHexColor as string);
                                props.onCanvasBackgroundEvent(szHexColor, false, isAllPage, mType);
                            }}></div>)
                        }
                    </div>
                </div>
            </Modal>
        </UIAppStateContext.Provider>
    )
})

export default DialogColorChoose;